
import styled from "styled-components";
import {mision,vision} from "../../assets/images";

const SectionWrapper = styled.section`
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 40px;
   font-family: Inter,  sans-serif;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  text-align: left;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-bottom: 16px;
  height:320px;
`;

const Heading = styled.h3`
  font-size: 20px;
  font-weight: 600;
 font-family: Inter,  sans-serif;
  margin-bottom: 12px;
`;

const Text = styled.p`
  font-size: 18px;
  line-height: 1.6;
  font-weight: 400;
  font-family: Inter,  sans-serif;
  color: #64636A;
`;

const MissionVisionSection = () => {
  return (
    <SectionWrapper>
      <Title>Our Mission and Vision</Title>
      <Grid>
        <Card>
          <Heading>Vision</Heading>
          <Text>
            Helping students — one at a time, with crucial information that
            helps them make educated choices. <br />
            We believe every student deserves access to transparent, data-driven
            insights to guide their journey. <br />
            By listening to real student voices, we uncover what truly matters in
            shaping academic and career success. <br />
            Our mission is to simplify decision-making and create meaningful
            pathways toward each student’s future.
          </Text>
        </Card>
        <Card>
          <Image src={vision} alt="Vision" />
        </Card>
        <Card>
          <Image src={mision} alt="Mission" />
        </Card>
        <Card>
          <Heading>Mission</Heading>
          <Text>
            Campus Insights is an AI-powered student engagement and analytics
            platform designed specifically for higher education institutions.
            <br /><br />
            Unlike generic chatbots, our solution leverages generative AI to
            deliver nuanced answers and real-time insights — from trending
            student queries to sentiment analysis — helping staff make
            data-informed decisions.
          </Text>
        </Card>
      </Grid>
    </SectionWrapper>
  );
};

export default MissionVisionSection;
